import React, {useState} from 'react';
import { ButtonField, Iconsvg, TextareaField } from '@wk/components-react16';
import { Toast } from '../../../services';
import { API_URL } from '../../../config/constants';
import HttpService from "../../../config/http.service";
import { useDispatch } from 'react-redux';
import { showLoading, hideLoading } from "../../../store/authReducer";

const PromptUserDefined = ({ data }: any) => {
    const { guidedPromptPayload, setGuidedPromptPayload, prompt, setPrompt, creatPromptType, setCreatPromptType, promptTypeList } = data;
	const dispatch = useDispatch();
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const handleInputChange = (index: number, event: any) => {
        const newList = [...guidedPromptPayload];
        const { name, value } = event.target;
        newList[index][name] = value;
        setGuidedPromptPayload(newList);
    };

    const onNextQ = () => {
        if (currentQuestionIndex < guidedPromptPayload.length) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        }
    }

    const onPreviousQ = () => {
        if (currentQuestionIndex < guidedPromptPayload.length) {
            setCurrentQuestionIndex(currentQuestionIndex - 1);
        }
    }

    const isValid = () => {
        for (let item of guidedPromptPayload) {
            if (!item.answer || !item.answer.trim()) {
                Toast('All answer fields must be filled.', "error");
                return false;
            }
        }
        return true;
    };

    const handleGuidedPrompt = async () => {
        if (!isValid()) return;
        dispatch(showLoading());
        const payload: any = {
            guidedQuestions: guidedPromptPayload
        }
        HttpService.postRequest(`${API_URL.GUIDED_PROMPT}`, payload).then((res: any) => {
            if (res.data) {
                let promptType: any = null;
                if (res.data.promptType) {
                    promptType = promptTypeList.find((item: any) => item.code.toUpperCase() === res.data.promptType.toUpperCase());
                }
                setPrompt({ ...prompt, name: res.data.promptName, text: res.data.promptText, promptType: promptType });
                setCreatPromptType(true);
            }
            dispatch(hideLoading());
        },
        (err: any) => {
            Toast(err.message, "error");
            dispatch(hideLoading());
        })
    }

    return (
        <div className="pr-15 pt-15 card-maxwidth">
            {guidedPromptPayload.length > 0 ? (
                <div key={currentQuestionIndex}>
                    <div className="text-center mb-40 position-relative">
                        <h5 className="" style={{ color: '#FF6ECF' }}>
                            {(currentQuestionIndex + 1) < 10 ? `0${currentQuestionIndex + 1}` : currentQuestionIndex+1}
                            <span className='wk-text-muted'>/
                            {guidedPromptPayload.length < 10 ? `0${guidedPromptPayload.length}` : guidedPromptPayload.length}</span>
                        </h5>
                        <hr className="divider" />
                    </div>
                    <h5 className='pr-30 pt-20 pb-20'>{currentQuestionIndex + 1}. {guidedPromptPayload[currentQuestionIndex].question}</h5>
                    <div className='mb-20 q-card'>
                        <div className='fade-in'>
                            <div className='pl-30 pr-30 pt-15 pb-15'>
                                <div className='wk-size-4'><span className='wk-weight-500'>Example:</span> "{guidedPromptPayload[currentQuestionIndex].example}"</div>
                                <div className="mb-15 mt-15">
                                    <TextareaField labelFor="textarea-id-1-1" indicator="required">
                                        <textarea style={{ height: '10rem' }}
                                            id={`textarea-id-${currentQuestionIndex}`} name="answer"
                                            placeholder='Enter your input...'
                                            onChange={(event: any) => handleInputChange(currentQuestionIndex, event)}
                                            value={guidedPromptPayload[currentQuestionIndex].answer}
                                        ></textarea>
                                    </TextareaField>
                                </div>
                            </div>
                            <div className='flex pl-30 pr-30 pb-30'>
                                {currentQuestionIndex > 0 && (
                                    <div className="flex-left">
                                        <ButtonField mode={'ghost'}>
                                            <button type="button" id="prevbtn" disabled={false} onClick={() => onPreviousQ()}><Iconsvg name="arrow-left"></Iconsvg> Prev</button>
                                        </ButtonField>
                                    </div>
                                )}
                                <div className="flex-right">
                                    {currentQuestionIndex < guidedPromptPayload.length - 1 ? (
                                        <ButtonField mode={'ghost'}>
                                            <button type="button" id="prevbtn" disabled={!guidedPromptPayload[currentQuestionIndex].answer} onClick={() => onNextQ()}>Next <Iconsvg name="arrow-right"></Iconsvg></button>
                                        </ButtonField>
                                    ) : ( currentQuestionIndex === guidedPromptPayload.length - 1 && (
                                        <ButtonField>
                                            <button type="button" disabled={!guidedPromptPayload[currentQuestionIndex].answer}
                                        onClick={() => handleGuidedPrompt()}>
                                                Get Guided Prompt
                                            </button>
                                        </ButtonField>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : null}
        </div>
    )
}

export default PromptUserDefined